<template>
  <div class="col-md-12">
    <label class="c-radio">
      <input
        id="inlineradio1"
        type="radio"
        name="i-radio"
        value="option1"
        @click="today"
        :checked="selected==='today'">
      <span class="fa fa-circle"></span> {{ $t('reportconsolidated.today') }}
    </label>
    <label class="c-radio">
      <input
        id="inlineradio2"
        type="radio"
        name="i-radio"
        value="option2"
        @click="yesterday"
        :checked="selected==='yesterday'">
      <span class="fa fa-circle"></span> {{ $t('reportconsolidated.yesterday') }}
    </label>
    <label class="c-radio">
      <input
        id="inlineradio3"
        type="radio"
        name="i-radio"
        value="option3"
        @click="current_week"
        :checked="selected==='current_week'">
      <span class="fa fa-circle"></span> {{ $t('reportconsolidated.current-week') }}
    </label>
    <label class="c-radio">
      <input
        id="inlineradio4"
        type="radio"
        name="i-radio"
        value="option4"
        @click="current_month"
        :checked="selected==='current_month'">
      <span class="fa fa-circle"></span> {{ $t('reportconsolidated.current-month') }}
    </label>
    <label class="c-radio">
      <input
        id="inlineradio5"
        type="radio"
        name="i-radio"
        value="option5"
        @click="last_week"
        :checked="selected==='last_week'">
      <span class="fa fa-circle"></span> {{ $t('reportconsolidated.last-week') }}
    </label>
    <label class="c-radio active">
      <input
        id="inlineradio6"
        type="radio"
        name="i-radio"
        value="option6"
        @click="last_month"
        :checked="selected==='last_month'">
      <span class="fa fa-circle"></span> {{ $t('reportconsolidated.last-month') }}
    </label>
    <label class="c-radio">
      <input
        id="inlineradio8"
        type="radio"
        name="i-radio"
        value="option8"
        @click="last_3_months"
        :checked="selected==='last_3_months'">
      <span class="fa fa-circle"></span> {{ $t('reportconsolidated.last-3-months') }}
    </label>
    <label class="c-radio">
      <input
        id="inlineradio9"
        type="radio"
        name="i-radio"
        value="option9"
        @click="last_6_months"
        :checked="selected==='last_6_months'">
      <span class="fa fa-circle"></span> {{ $t('reportconsolidated.last-6-months') }}
    </label>
    <label class="c-radio">
      <input
        id="inlineradio10"
        type="radio"
        name="i-radio"
        value="option10"
        @click="last_year"
        :checked="selected==='last_year'">
      <span class="fa fa-circle"></span> {{ $t('reportconsolidated.last-year') }}
    </label>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      selected: 'last_month'
    }
  },
  methods: {
    today () {
      this.$parent.filter_start = moment().toISOString()
      this.$parent.filter_finish = null
      this.selected = 'today'
    },
    yesterday () {
      this.$parent.filter_start = moment().subtract(1, 'days').toISOString()
      this.$parent.filter_finish = null
      this.selected = 'yesterday'
    },
    current_week () {
      this.$parent.filter_start = moment().startOf('isoweek').toISOString()
      this.$parent.filter_finish = null
      this.selected = 'current_week'
    },
    current_month () {
      this.$parent.filter_start = moment().startOf('month').toISOString()
      this.$parent.filter_finish = null
      this.selected = 'current_month'
    },
    last_week () {
      this.$parent.filter_start = moment().subtract(1, 'week').startOf('isoweek').toISOString()
      this.$parent.filter_finish = null
      this.selected = 'last_week'
    },
    last_month () {
      this.$parent.filter_start = moment().subtract(1, 'month').startOf('month').toISOString()
      this.$parent.filter_finish = null
      this.selected = 'last_month'
    },
    last_3_months () {
      this.$parent.filter_start = moment().subtract(3, 'month').toISOString()
      this.$parent.filter_finish = null
      this.selected = 'last_3_months'
    },
    last_6_months () {
      this.$parent.filter_start = moment().subtract(6, 'month').toISOString()
      this.$parent.filter_finish = null
      this.selected = 'last_6_months'
    },
    last_year () {
      this.$parent.filter_start = moment().subtract(1, 'year').toISOString()
      this.$parent.filter_finish = null
      this.selected = 'last_year'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Datefilters.vue